"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _order = require("@/api/order");
var _agreeToReturn = _interopRequireDefault(require("./agreeToReturn.vue"));
var _DetailHeader = _interopRequireDefault(require("@/components/base/DetailHeader.vue"));
var _DetailInfo = _interopRequireDefault(require("@/components/base/DetailInfo.vue"));
var _filters = require("@/filters");
var _useRefundOrder2 = _interopRequireDefault(require("@/libs/useRefundOrder"));
var _permission = require("@/utils/permission");
var _productEnums = require("@/enums/productEnums");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _useRefundOrder = (0, _useRefundOrder2.default)(),
  onConfirmReceipt = _useRefundOrder.onConfirmReceipt,
  onApprovedReview = _useRefundOrder.onApprovedReview;
var _default = exports.default = {
  name: 'refundOrderDetail',
  props: {
    //退款单号
    refundOrderNo: {
      type: String,
      default: 0
    },
    //是否显示隐藏
    drawerVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DetailHeader: _DetailHeader.default,
    DetailInfo: _DetailInfo.default,
    AgreeToReturn: _agreeToReturn.default
  },
  computed: {
    headerList: function headerList() {
      return [{
        label: '退款状态',
        value: (0, _filters.refundStatusFilter)(this.refundInfo.refundStatus),
        color: 'color-warning'
      }, {
        label: '退款金额',
        value: '¥ ' + (this.refundInfo.refundPrice || '0.0')
      }, {
        label: '实付金额',
        value: this.refundInfo.payPrice
      }, {
        label: '创建时间',
        value: this.refundInfo.orderInfoVo ? this.refundInfo.orderInfoVo.createTime : ''
      }];
    },
    orderDetailList: function orderDetailList() {
      var info = this.refundInfo.orderInfoVo || {};
      var _this$$options$filter = this.$options.filters,
        filterEmpty = _this$$options$filter.filterEmpty,
        payTypeFilter = _this$$options$filter.payTypeFilter,
        orderStatusFilter = _this$$options$filter.orderStatusFilter;
      var list = [{
        title: '用户信息',
        list: [{
          label: '用户昵称',
          slot: 'nickname'
        }, {
          label: '用户电话',
          value: info.phone
        }]
      }];
      if (info.shippingType < 3 && info.secondType !== 2) {
        list.push({
          title: '配送信息',
          bottomSlot: 'userAddress',
          list: [{
            label: '配送方式',
            value: info.shippingType === 1 ? '商家配送' : '到店自提'
          }, {
            label: '收货电话',
            value: filterEmpty(info.userPhone)
          }, {
            label: '收货人',
            value: filterEmpty(info.realName)
          }]
        });
      }
      list.push({
        title: '订单信息',
        list: [{
          label: '订单号',
          value: info.orderNo
        }, {
          label: '商品总数',
          value: info.totalNum
        }, {
          label: '支付状态',
          value: info.paid ? '已支付' : '未支付'
        }, {
          label: '支付方式',
          value: payTypeFilter ? payTypeFilter(info.payType) : info.payType
        }, {
          label: '订单状态',
          slot: 'orderStatus',
          class: 'textE93323'
        }, {
          label: '已发货数量',
          value: info.deliveryNum
        }, {
          label: '创建时间',
          value: info.createTime
        }, {
          label: '支付时间',
          value: info.payTime
        }]
      });
      list.push({
        title: '订单明细',
        list: [{
          label: '商品总价',
          value: '￥' + info.proTotalPrice
        }, {
          label: '平台优惠金额',
          value: '￥' + info.platCouponPrice
        }, {
          label: '赠送积分',
          value: '￥' + info.gainIntegral
        }, {
          label: '实际支付',
          value: '￥' + (info.payPrice || '0.0')
        }, {
          label: '扣除抵扣积分',
          value: info.useIntegral
        }, {
          label: '商家优惠金额',
          value: '￥' + (info.merCouponPrice || '0.0')
        }, {
          label: '商户会员抵扣',
          value: '￥' + (info.merchantMemberDiscountPrice || '0.0')
        }, {
          label: 'SVIP抵扣',
          value: '￥' + (info.svipDiscountPrice || '0.0')
        }, {
          label: '支付邮费',
          value: '￥' + (info.payPostage || '0.0')
        }, {
          label: '积分抵扣金额',
          value: '￥' + (info.integralPrice || '0.0')
        }]
      });
      if (info.secondType == this.OrderSecondTypeEnum.PunchCard) {
        list.push({
          title: '核销信息',
          list: [{
            label: '待核销次数',
            value: this.refundInfo.verifyRemainingTimes
          }, {
            label: '总次数',
            value: this.refundInfo.verifyTotalTimes
          }]
        });
      }
      list.push({
        title: '用户备注',
        list: [{
          label: '',
          value: filterEmpty(info.userRemark),
          class: 'productName',
          type: 'lang'
        }]
      });
      list.push({
        title: '商家备注',
        list: [{
          label: '',
          value: filterEmpty(info.merchantRemark),
          class: 'productName',
          type: 'lang'
        }]
      });
      return list;
    }
  },
  data: function data() {
    return {
      activeName: 'refund',
      dialogVisible: false,
      loadingBtn: false,
      direction: 'rtl',
      reverse: true,
      orderDatalist: {},
      loading: false,
      modal2: false,
      result: [],
      resultInfo: {},
      refundInfo: {},
      OrderSecondTypeEnum: _productEnums.OrderSecondTypeEnum
    };
  },
  mounted: function mounted() {
    this.getRefundOrderDetail(this.refundOrderNo);
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 备注
    onOrderMark: function onOrderMark() {
      var _this = this;
      this.$modalPrompt('textarea', '备注', this.refundInfo.merRemark, '退款单备注').then(function (V) {
        (0, _order.refundMarkApi)({
          remark: V,
          refundOrderNo: _this.refundOrderNo
        }).then(function () {
          _this.$message.success('操作成功');
          _this.getRefundOrderDetail(_this.refundOrderNo);
          _this.$emit('getReviewSuccessful');
        });
      });
    },
    //拒绝收货
    handleRefuseReceipt: function handleRefuseReceipt() {
      var _this2 = this;
      this.$modalPrompt('textarea', '拒绝收货', null, '拒绝收货原因').then(function (V) {
        (0, _order.refundOrderReceivingRejectApi)({
          reason: V,
          refundOrderNo: _this2.refundOrderNo
        }).then(function () {
          _this2.$message.success('拒绝收货成功');
          _this2.getSuccessful();
        });
      });
    },
    //商家确认收货
    handleConfirmReceipt: function handleConfirmReceipt() {
      var _this3 = this;
      onConfirmReceipt(this.refundOrderNo).then(function () {
        _this3.getSuccessful();
      });
    },
    //审核同意
    handleApprovedReview: function handleApprovedReview() {
      var _this4 = this;
      if (this.refundInfo.returnGoodsType !== 1) {
        onApprovedReview({
          auditType: 'success',
          refundOrderNo: this.refundInfo.refundOrderNo
        }).then(function () {
          _this4.handleSuccess();
        });
      } else {
        //退货退款
        this.dialogVisible = true;
      }
    },
    //审核成功回调
    handleSuccess: function handleSuccess() {
      this.dialogVisible = false;
      this.getSuccessful();
    },
    //操作成功之后的回调，比如关闭弹窗，刷新列表等
    getSuccessful: function getSuccessful() {
      this.getRefundOrderDetail(this.refundOrderNo);
      this.$emit('getReviewSuccessful');
      this.handleClose();
    },
    //同意弹窗
    handleCloseAgreeToReturn: function handleCloseAgreeToReturn() {
      this.dialogVisible = false;
    },
    //审核拒绝
    handleOrderRefuse: function handleOrderRefuse() {
      var _this5 = this;
      this.$modalPrompt('textarea', '拒绝退款', null, '拒绝退款原因').then(function (V) {
        (0, _order.orderAuditApi)({
          auditType: 'refuse',
          reason: V,
          refundOrderNo: _this5.refundInfo.refundOrderNo
        }).then(function () {
          _this5.$message.success('审核成功');
          _this5.getSuccessful();
        });
      });
    },
    handleClose: function handleClose() {
      this.$emit('onClosedrawerVisible');
    },
    // 获取订单退款信息
    getRefundOrderDetail: function getRefundOrderDetail(id) {
      var _this6 = this;
      this.loading = true;
      (0, _order.refundOrderDetailApi)(id).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                _this6.refundInfo = res;
                _this6.loading = false;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function () {
        _this6.loading = false;
      });
    }
  }
};